// @flow
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { isLoadingSelector } from '../../../../../modules/LoadingStatus/reducer';
import { compose } from 'react-recompose';
import PromotionCodePage from './PromotionCodePage';
import ValidationService from '../../../../../lib/validation';
import { verifyPromotionCode } from '../../../../../modules/SignUp/Bonus/actions';
import { godfatherExternalIdSelector, shouldShowGodfatherSelector } from '../../../../../modules/SignUp/Bonus/reducer';

const validate = values => ({
  code: ValidationService.validatePromotionCode(values.code),
});

const mapStateToProps = state => {
  return {
    isLoading: isLoadingSelector(state, 'verifyPromotionCode'),
    initialValues: {
      code: shouldShowGodfatherSelector(state) ? godfatherExternalIdSelector(state) : '',
    },
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: form => {
    dispatch(verifyPromotionCode(form.code));
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({ form: 'PromotionCodePage', validate })
)(PromotionCodePage);
